// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SeasonalDiscountUnibrow-cls1___36a7ae458cb9a2cc7b2{/*!*/}.SeasonalDiscountUnibrow-cls2___ee2ef15e24e8d6b0c5e{color:#fff;font-size:20px;font-weight:400;letter-spacing:.03em;margin:0 20px 0 10px;opacity:.8;text-transform:uppercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SeasonalDiscountUnibrow-cls1___36a7ae458cb9a2cc7b2",
	"cls2": "SeasonalDiscountUnibrow-cls2___ee2ef15e24e8d6b0c5e SeasonalDiscountUnibrow-cls1___36a7ae458cb9a2cc7b2"
};
export default ___CSS_LOADER_EXPORT___;
